import { classNames } from "../../helpers/classNames";
import "./styles/Loader.css"; // Make sure to create this CSS file and paste the styles there

const Loader = ({ className }) => {
  return <div class={classNames("loader", className)}></div>;
};

export default Loader;
